export default "__VITE_ASSET__B30bK$Eq__"